import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useCore } from './useCore';
import { client } from '../services/api';
import { toast } from 'react-hot-toast';
import { toastConfig, createCustomToast, successToastConfig, dangerToastConfig } from '../utils/data';
import { cptData, jCodeData } from '../utils/codeData';
import { getCodeMeta, getDiagnosisMeta } from '../utils/codeTools';
import { useOrganization } from './useOrganization';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  // Add your core state here
  const { user, organization } = useAuth();
  const { accountSelected, getAccountsList } = useOrganization();
  const { theme } = useCore();
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [fileUploadProgressInterval, setFileUploadProgressInterval] = useState(null);
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lookupLoading, setLookupLoading] = useState(false);
  const [bulkRepriceLoading, setBulkRepriceLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);

  const [filesQuery, setFilesQuery] = useState([]);
  const [filesOpen, setFilesOpen] = useState([]);
  const [fileOpenId, setFileOpenId] = useState(null);
  const [claimOpenId, setClaimOpenId] = useState(null);
  const [appliedClaimSearchTerm, setAppliedClaimSearchTerm] = useState('');
  const [searchDraft, setSearchDraft] = useState('');
  const [dateRangeFilter, setDateRangeFilter] = useState({ from: '', to: '' });
  const [dateRangeDraft, setDateRangeDraft] = useState({ from: '', to: '' });
  const [searchCodes, setSearchCodes] = useState([]);
  const [codes, setCodes] = useState({});
  const [claimLines, setClaimLines] = useState([]);
  const [claimDiagnoses, setClaimDiagnoses] = useState([]);

  const [reprice, setReprice] = useState('reprice data here');
  const [audit, setAudit] = useState(null);
  const [lookup, setLookup] = useState(null);

  const handleFile = (f) => {
    setFile(f);
  }

  
  const handleReprice = (r) => {
    setReprice(r);
  }

  const handleAudit = (d) => {
    setAudit(d);
  }

  const handleLookup = (d) => {
    setLookup(d);
  }

  const handleCodes = (d) => {
    setCodes(d);
  }

  const handleFilteredFiles = (d) => {
        setFilteredFiles(d);
  }

  const handleAppliedClaimSearchTerm = (value) => {
    setAppliedClaimSearchTerm(value);
  }

  const handleSearchDraft = (value) => {
    setSearchDraft(value);
  }

  const handleDateRangeFilter = (value) => {
    setDateRangeFilter(value);
  }

  const handleDateRangeDraft = (value) => {
    setDateRangeDraft(value);
  }

  const handleSearchCodes = (d, theme="light") => {
    // Validate all codes in d
    const validCodes = [];
    d.forEach(code => {
      code = String(code).toUpperCase();
      if (/^[A-Z]\d{4}$/.test(code)) {
        validCodes.push(code);
        return;
      }
      const numCode = parseInt(code, 10);
      let foundSection = null;
      let foundSubsection = null;
      for (const section of Object.values(cptData)) {
        if (numCode >= section.rangeStart && numCode <= section.rangeEnd) {
          foundSection = section;
          if (section.subsections) {
            for (const sub of Object.values(section.subsections)) {
              if (numCode >= sub.rangeStart && numCode <= sub.rangeEnd) {
                foundSubsection = sub;
                break;
              }
            }
          }
          break;
        }
      }
      if (foundSection) {
        validCodes.push(code);
      } else {
        // toast('invalid code', toastConfig);
                createCustomToast('Invalid code.', theme);
      }
    });
    setSearchCodes(validCodes);
  }

  const fetchCodeLookups = async (requestedCodes = searchCodes) => {
    setLookupLoading(true);
    
    let newCodes = [];
    for(let i = 0; i < requestedCodes.length; i++){
            if(codes[requestedCodes[i]] == undefined){
        newCodes.push(requestedCodes[i]);
      }
    }
    if (newCodes.length === 0) {
      setLookupLoading(false);
      return;
    }
    let codesLookup = newCodes.join(',');
  
    let cs = await client.lookupCodes(codesLookup);
    if(cs.status === 200 && cs.data?.data?.length){
      let data = cs.data.data;
      const fetchedCodes = {};
      for(let i = 0; i < data.length; i++){
        const rawCode = data[i].code.toString().toUpperCase();
        let keycode = /^\d+$/.test(rawCode) ? rawCode.padStart(5, '0') : rawCode;
        fetchedCodes[keycode] = data[i];
      }
      setCodes(currentCodes => ({ ...currentCodes, ...fetchedCodes }));
    }
    setLookupLoading(false);
        // let c = { ...codes };
    // cptDataResultMock.forEach(code => {
    //   c[code.code] = code;
    // });
    
    // setTimeout(() => {
    //   setLoading(false);
    //   setCodes(c);
    // }, 3000);
  }
  


  let codeKeys = {
    "cms_geosvc": {
      name: "hospital lookup"
    },
    "cms_opps_b": {
      name: "opps dept"
    },
    "cms_fee_schedule": {
      name: "cms fee slookup"
    },
    "cms": {
      name: "hospital lookup"
    },
  }

  const buildClaims = (f) => {

    let c = [...f.data.file.claims];
        let claimLinesTemp = [];
    let claimDiagnosesTemp = [];
    for(var i=0;i<c.length;i++){

      let slines = [...c[i].serviceLines];
            let serviceLines = [];

      for(var j=0;j<slines.length;j++){
        let code = null;
        let sl = slines[j];
        if(sl.hcpcs === undefined || sl.hcpcs === null || sl.hcpcs === ""){
          code = "N/A";
        }else if(sl.hcpcs){
          code = sl.hcpcs?.replace("HC:","");
          code = code.split(":")[0];
        }

        let lineMeta = null;
        if(code.startsWith("J")){
          let jcode = code.split("J")[1];
          lineMeta = getCodeMeta(jcode, jCodeData);
        }else{
          lineMeta = getCodeMeta(code);
                  }
          
        let revCode = sl.revenueCode;
        let revCodeMeta = getCodeMeta(revCode);
        
        

        let sline = {
          code: code,
          codeMeta: lineMeta,
          revenueCode: sl.revenueCode,
          revenueCodeMeta: revCodeMeta,
          chargeAmount: sl.chargeAmount,
          quantity: sl.quantity,
          // section: lineMeta.section,
          // sectionColor: lineMeta.sectionColor,
          // sectionIcon: lineMeta.sectionIcon,
          // subSection: lineMeta.subSection,
          // subSectionColor: lineMeta.subSectionColor,
          // subSectionIcon: lineMeta.subSectionIcon,
          // description: lineMeta.description
        }

        serviceLines.push(sline);

      }

      let diagnoses = [];
      let ds = [...c[i].diagnoses];

      for(var j=0;j<ds.length;j++){
        let dMeta = getDiagnosisMeta(ds[j]);
        let d = {
          code: ds[j].code,
          qualifier: ds[j].qualifier,
          color: dMeta.color,
          section: dMeta.section,
          description: dMeta.description
        }
        diagnoses.push(d);
      }
                  claimLinesTemp.push(serviceLines);
      claimDiagnosesTemp.push(diagnoses);

      
    }

    setClaimLines(claimLinesTemp);
    setClaimDiagnoses(claimDiagnosesTemp);

        
  }

  const getFileBySlug = async (slug) => {
    let file = await client.getFileBySlug(slug);
    if(file.data && file.ok){
    
      let f = file.data;
      
      let ofiles = {...filesOpen};
      ofiles[f.slug] = f;
      setFileOpenId(f.slug);
      setFilesOpen(ofiles);
      buildClaims(f);

    }else{
      toast('File not found',dangerToastConfig);
    }
    
  }

  const openFile = (f) => {
    let ofiles = {...filesOpen};
    ofiles[f.slug] = f;
    setFileOpenId(f.slug);
    setFilesOpen(ofiles);
    buildClaims(f);
  }

  const getFilesByOrg = async () => {
    if(accountSelected){
      let f = await client.getFilesByOrg(accountSelected);
            
      // Sort files by created date (most recent first)
      const sortedFiles = (f.data || []).sort((a, b) => {
        const dateA = new Date(a.created || 0);
        const dateB = new Date(b.created || 0);
        return dateB - dateA; // Most recent first
      });
      
      setFiles(sortedFiles);
    }
  }


  const handleFilesUpload = (ufiles) => {
            
    let newFiles = [];
    let alreadyUploadedFiles = [];
    
    if(files.length > 0){
      for(var j = 0; j < ufiles.length; j++){
        let found = false;
        for(var i = 0; i < files.length; i++){
          if(files[i].name === ufiles[j].name && files[i].size === ufiles[j].size){
                        found = true;
            alreadyUploadedFiles.push(ufiles[j].name);
          }
        }
        if(!found){
          newFiles.push(ufiles[j]);
        }
      }
    }else{
      newFiles = ufiles;
    }
    
    // Show toast for already uploaded files
    if (alreadyUploadedFiles.length > 0) {
      const fileNames = alreadyUploadedFiles.join(', ');
      toast(`File(s) already uploaded: ${fileNames}`, toastConfig);
    }
    
    for(var i = 0; i < newFiles.length; i++){
      newFiles[i].status = 'uploading';
      newFiles[i].progress = 0;
      newFiles[i].error = null;
      newFiles[i].uploading = true;
      let farray = newFiles[i].name.split('.');
      newFiles[i].fname = farray[0];
      newFiles[i].ext = farray[1];
      newFiles[i].completed = false;
    }
    
    // Only add the new files to uploads, don't combine with existing API files
    setUploads(prevUploads => {
      const updatedUploads = [...prevUploads, ...newFiles];
            return updatedUploads;
    });
    
    // Trigger upload immediately with just the new files
    if (newFiles.length > 0) {
      uploadFilesToServer(newFiles);
    }
    
      };



 

  // Separate function that accepts files as parameter to avoid stale closure
  const uploadFilesToServer = useCallback(async (filesToUpload) => {
        if (!filesToUpload.length) return;
    let token = localStorage.getItem("token");
    
    // Track progress updates to debounce them
    const progressUpdateTimeouts = new Map();
    
    for (let i = 0; i < filesToUpload.length; i++) {
      const file = filesToUpload[i];
            
      // Update the file properties
      file.status = 'uploading';
      file.error = null;
      file.uploading = true;
      file.progress = 0;
      
      // The files are already in the uploads array from handleFilesUpload
      // We just need to trigger a re-render to show the updated status
      setUploads(prevUploads => [...prevUploads]);
      
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('lastModified', file.lastModified);
        formData.append('accountSelected', accountSelected);
       
                // You can add more fields to formData if needed
        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          file._xhr = xhr; // Attach xhr to file for cancellation
          let path = `${process.env.REACT_APP_VERITAS_API_URL}/api/file/upload`;
          xhr.open('POST', path);
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              const percent = Math.round((event.loaded / event.total) * 100);
              const oldProgress = file.progress;
              file.progress = percent;
              
              // Only update state if progress changed significantly (every 5% or at 100%)
              if (percent === 100 || Math.abs(percent - oldProgress) >= 5) {
                // Clear any existing timeout for this file
                if (progressUpdateTimeouts.has(file.name)) {
                  clearTimeout(progressUpdateTimeouts.get(file.name));
                }
                
                // Debounce the state update
                const timeoutId = setTimeout(() => {
                  setUploads(prevUploads => [...prevUploads]);
                  progressUpdateTimeouts.delete(file.name);
                }, 100); // 100ms debounce
                
                progressUpdateTimeouts.set(file.name, timeoutId);
              }
            }
          };
          xhr.onload = () => {
            // Clear any pending progress update
            if (progressUpdateTimeouts.has(file.name)) {
              clearTimeout(progressUpdateTimeouts.get(file.name));
              progressUpdateTimeouts.delete(file.name);
            }
            
            if (xhr.status >= 200 && xhr.status < 300) {
              file.status = 'completed';
              file.error = null;
              file.completed = true;
              file.uploading = false;
              file.progress = 100;
              setUploads(prevUploads => [...prevUploads]);
              resolve();
            } else {
              file.status = 'error';
              file.error = `Upload failed: ${xhr.statusText}`;
              file.uploading = false;
              setUploads(prevUploads => [...prevUploads]);
                            reject(new Error(xhr.statusText));
            }
          };
          xhr.onerror = () => {
            // Clear any pending progress update
            if (progressUpdateTimeouts.has(file.name)) {
              clearTimeout(progressUpdateTimeouts.get(file.name));
              progressUpdateTimeouts.delete(file.name);
            }
            
            file.status = 'error';
            file.error = 'Network error';
            file.uploading = false;
            setUploads(prevUploads => [...prevUploads]);
            reject(new Error('Network error'));
          };
          xhr.send(formData);
        });
      } catch (err) {
        // Error already handled above
      }
    }
  }, [accountSelected]);

  // Remove an upload and cancel if in progress
  const removeUpload = useCallback((index) => {
    setUploads(prevUploads => {
      const file = prevUploads[index];
      if (file && file._xhr && file.uploading && file.progress < 100) {
        try { file._xhr.abort(); } catch (e) { /* ignore */ }
      }
      const newUploads = prevUploads.filter((_, i) => i !== index);
      return newUploads;
    });
  }, []);

  // Clear all uploads and cancel any in progress
  const clearUploads = useCallback(() => {
    setUploads(prevUploads => {
      // Cancel any ongoing uploads
      prevUploads.forEach(file => {
        if (file && file._xhr && file.uploading && file.progress < 100) {
          try { file._xhr.abort(); } catch (e) { /* ignore */ }
        }
      });
      return [];
    });
  }, []);

  // Update fileUploadProgress as normalized average of all uploads
  useEffect(() => {
    if (uploads.length === 0) {
      setFileUploadProgress(0);
    } else {
      // Only consider files that are uploading or not errored
      const validUploads = uploads.filter(f => f.status !== 'error');
      if (validUploads.length === 0) {
        setFileUploadProgress(0);
      } else {
        const total = validUploads.reduce((sum, f) => sum + (f.progress || 0), 0);
        const avg = total / validUploads.length;
        setFileUploadProgress(Math.round(avg));
      }
    }
  }, [uploads]);

  const handleLoading = (l) => {
    setLoading(l);
  }

  const handleFileOpenId = (id) => {
    setFileOpenId(id);
  }

  const handleClaimOpenId = (id) => {
    setClaimOpenId(id);
  }

  const closeOpenFile = (id) => {
    let ofiles = {...filesOpen};
    delete ofiles[id];
    setFilesOpen(ofiles);
  }

  const fetchFilesQuery = async (query) => {
    let q = {
      org: user.organization._id,
      ...query
    }
    if(query.search.length > 1){
      let f = await client.queryFiles(q);
          }
    
  }

  const processFile = async (slug, type="reprice") => {
    setLoading(true);
    const selectedAccount = getAccountsList.find(account => account._id === accountSelected);
        let pdata = {
      slug: slug,
      type: type,
      markUp: selectedAccount.settings.markUp
    }
    let rf = await client.processFile(pdata);
        toast('File repriced successfully', successToastConfig);
    let file = await client.getFileBySlug(slug);
    if(file.data && file.ok){
    
      let f = file.data;
      
      let ofiles = {...filesOpen};
      ofiles[f.slug] = f;
      setFileOpenId(f.slug);
      setFilesOpen(ofiles);
      buildClaims(f);

    }
    getFilesByOrg();
    setLoading(false);
  }

  const processBulkReprice = async () => {
    if (bulkRepriceLoading) {
      return;
    }

    const selectedAccount = getAccountsList.find(account => account._id === accountSelected);
    if (!selectedAccount) {
      toast('Select an account before bulk reprice', toastConfig);
      return;
    }

    const uploadedFiles = files.filter(file => file.status === 'uploaded');
    const payload = uploadedFiles.map(file => ({
      slug: file.slug,
      type: 'reprice',
      markUp: selectedAccount.settings?.markUp
    }));

    if (payload.length === 0) {
      toast('No uploaded files to reprice', toastConfig);
      return;
    }

    setBulkRepriceLoading(true);
    toast('Bulk reprice is in progress. This can take a few minutes, so you can keep working and check back later.', toastConfig);

    try {
            let rf = await client.processBulkReprice(payload);
      
      if (rf.ok) {
        toast('Files repriced successfully', successToastConfig);
        await getFilesByOrg();
      } else if (rf.problem === 'TIMEOUT_ERROR') {
        toast('Bulk reprice is taking longer than expected', dangerToastConfig);
      } else {
        toast('Bulk reprice failed', dangerToastConfig);
      }
    } catch (error) {
      console.error('bulk reprice error', error);
      toast('Bulk reprice failed', dangerToastConfig);
    } finally {
      setBulkRepriceLoading(false);
    }
  }

  const value = {
    loading,
    lookupLoading,
    bulkRepriceLoading,
    handleLoading,
    file,
    handleFile,
    openFile,
    fileOpenId,
    closeOpenFile,
    handleFileOpenId,
    claimOpenId,
    handleClaimOpenId,
    files,
    setFiles,
    filesOpen,
    setFilesOpen,
    codes,
    handleCodes,
    buildClaims,
    claimLines,
    claimDiagnoses,
    setClaimLines,
    setClaimDiagnoses,
    searchCodes,
    handleSearchCodes,
    reprice,
    audit,
    lookup,
    uploads,
    setUploads,
    fileUploadProgress,
    setFileUploadProgress,
    handleFilesUpload,
    uploadFilesToServer,
    getFilesByOrg,
    getFileBySlug,
    removeUpload,
    clearUploads,
    fetchCodeLookups,
    filteredFiles,
    handleFilteredFiles,
    appliedClaimSearchTerm,
    handleAppliedClaimSearchTerm,
    searchDraft,
    handleSearchDraft,
    dateRangeFilter,
    handleDateRangeFilter,
    dateRangeDraft,
    handleDateRangeDraft,
    fetchFilesQuery,
    filesQuery,
    setFilesQuery,
    processFile,
    processBulkReprice
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}; 
